// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c94ddc6f","57":"2a54ada3","124":"05c6faef","353":"9a7cc7f5","449":"4af09daf","453":"703d9625","660":"26a53d6c","697":"35f57cc4","712":"77c983b4","819":"927e1b88"}[chunkId] + ".chunk.js";
};